import { getCookie } from './cookie'

// ab test based in USERID
// the user_id contains 0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f characters
export const abTest = (
  a = ['0', '1', '2', '3', '4', '5', '6', '7'],
): 'A' | 'B' => {
  const userId = getCookie('user_id')
  if (!userId) return 'A'
  return a.includes(userId?.charAt(0)) ? 'A' : 'B'
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const randomAbTest = (
  experiment: string,
  variants: string[],
): string => {
  if (!variants.length || variants.length < 2) {
    throw new Error('You must provide at least 2 variants')
  }

  const experiments = JSON.parse(
    localStorage.getItem('jb.state.abtest.experiments') || '{}',
  )
  if (experiments[experiment]) return experiments[experiment]
  const variantIndexOf = getRandomInt(0, variants.length - 1)
  experiments[experiment] = variants[variantIndexOf]
  localStorage.setItem(
    'jb.state.abtest.experiments',
    JSON.stringify(experiments),
  )
  return experiments[experiment]
}
